/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-07 11:17:28
 * @LastEditTime: 2019-07-24 14:05:45
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

// 登录后接受推送
export const getPush = params => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/personal/notification/getRead`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getRead'
      }, params))
    }
  })
}
